// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MarketplaceStage__root--DvSZT {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

    @media screen and (min-width: 1024px) {.MarketplaceStage__root--DvSZT {
        display: grid;
        grid-template-columns: 248px auto;
        grid-gap: 20px
}
    }

.MarketplaceStage__offerCard--pEtjo {
    display: flex;
    flex-direction: column-reverse;
    gap: 8px;
}

@media screen and (min-width: 1024px) {

.MarketplaceStage__offerCard--pEtjo {
        border: 1px solid var(--dark-tertiary-new-color);
        padding: 24px;
        border-radius: 6px;
        flex-direction: column;
        gap: 16px;
        position: relative
}
    }

.MarketplaceStage__cards--Mxple {
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
}

@media screen and (min-width: 1024px) {

.MarketplaceStage__cards--Mxple {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 16px;
        border: 1px solid var(--premium-solid-color);
        padding: 24px;
        border-radius: 6px
}
    }

.MarketplaceStage__transferIcon--l5nXW {
    display: none;
}

@media screen and (min-width: 1024px) {

.MarketplaceStage__transferIcon--l5nXW {
        display: flex;
        border-radius: 6px;
        border: 1px solid var(--premium-solid-color);
        background-color: var(--darkest-color);
        position: absolute;
        padding: 7px;
        top: 20px;
        left: -28px;
        z-index: 2
}

        .MarketplaceStage__transferIcon--l5nXW > svg {
            width: 40px;
            height: 40px;
        }
    }

.MarketplaceStage__card--LF4IN {
    width: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

@media screen and (max-width: 1023px) {

.MarketplaceStage__card--LF4IN {
        padding-top: 8px;
        width: 33vw
}

        .MarketplaceStage__card--LF4IN:nth-child(2) {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            padding-top: 0;
        }

        .MarketplaceStage__card--LF4IN:last-child {
            position: relative;
            z-index: 2;
        }
    }

.MarketplaceStage__cardName--A0lrE {
    color: var(--tertiary-color);
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    line-height: 2;
    letter-spacing: 0.6px;
    text-align: center;
}

@media screen and (min-width: 1024px) {

.MarketplaceStage__cardName--A0lrE {
        padding: 12px 16px
}
    }

.MarketplaceStage__cardImage--gqayM {
    width: 100%;
    height: auto;
    max-width: 180px;
    margin: 0 auto;
    aspect-ratio: 0.64;
    min-width: 115px;
    border-radius: 8px;
    cursor: pointer;
}

@media screen and (max-width: 518px) {

.MarketplaceStage__cardImage--gqayM {
        max-width: 115px
}
    }

@media screen and (min-width: 1024px) {

.MarketplaceStage__cardImage--gqayM {
        max-width: 246px
}
    }

.MarketplaceStage__starBlock--H0sc2 {
    margin: 0 auto;
    margin-bottom: 8px;
    color: var(--main-color);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    display: flex;
    justify-content: center;
}

@media (hover: hover) and (pointer: fine) {
            .MarketplaceStage__starBlock--H0sc2:not(.MarketplaceStage__active--R5rqO):hover .MarketplaceStage__iconStarBg--voPe6 {
                fill: #1E2028;
            }
    }

.MarketplaceStage__starBlock--H0sc2.MarketplaceStage__active--R5rqO {
        fill: var(--main-color);
    }

.MarketplaceStage__starBlock--H0sc2.MarketplaceStage__active--R5rqO .MarketplaceStage__iconStarBg--voPe6 {
            fill: var(--main-color);
        }

.MarketplaceStage__starBlock--H0sc2.MarketplaceStage__active--R5rqO .MarketplaceStage__iconStarMain--wErAt {
            fill: #090A0E;
        }

@media screen and (min-width: 1024px) {

.MarketplaceStage__starBlock--H0sc2 {
        margin-bottom: 16px
}
    }

.MarketplaceStage__iconStar--KyObA {
    width: 40px;
    height: 40px;
    cursor: pointer;
}

@media screen and (min-width: 1024px) {

.MarketplaceStage__iconStar--KyObA {
        width: 50px;
        height: 50px
}
    }

.MarketplaceStage__iconStarMain--wErAt {
    transition: fill 0.25s ease-in-out;
}

.MarketplaceStage__iconStarBg--voPe6 {
    fill: transparent;
    transition: fill 0.25s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/components/MarketplaceStage/MarketplaceStage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AAOb;;IALI,uCANJ;QAOQ,aAAa;QACb,iCAAiC;QACjC;AAER;IADI;;AAGJ;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AAUZ;;AARI;;AALJ;QAMQ,gDAAgD;QAChD,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,SAAS;QACT;AAER;IADI;;AAGJ;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AAUtB;;AARI;;AANJ;QAOQ,aAAa;QACb,qCAAqC;QACrC,cAAc;QACd,4CAA4C;QAC5C,aAAa;QACb;AAER;IADI;;AAGJ;IACI,aAAa;AAkBjB;;AAhBI;;AAHJ;QAIQ,aAAa;QACb,kBAAkB;QAClB,4CAA4C;QAC5C,sCAAsC;QACtC,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,WAAW;QACX;AAOR;;QALQ;YACI,WAAW;YACX,YAAY;QAChB;IACJ;;AAGJ;IACI,WAAW;IACX,eAAe;IACf,wCAAwC;AAkB5C;;AAhBI;;AALJ;QAMQ,gBAAgB;QAChB;AAcR;;QAZQ;YACI,kBAAkB;YAClB,SAAS;YACT,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,kBAAkB;YAClB,UAAU;QACd;IACJ;;AAGJ;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AAKtB;;AAHI;;AATJ;QAUQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AASnB;;AAPI;;AAVJ;QAWQ;AAMR;IALI;;AAEA;;AAdJ;QAeQ;AAER;IADI;;AAGJ;IACI,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,wCAAwC;IACxC,aAAa;IACb,uBAAuB;AAyB3B;;AAvBI;YAEQ;gBACI,aAAa;YACjB;IAER;;AAEA;QACI,uBAAuB;IAS3B;;AAPI;YACI,uBAAuB;QAC3B;;AAEA;YACI,aAAa;QACjB;;AAGJ;;AA7BJ;QA8BQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AAMnB;;AAJI;;AALJ;QAMQ,WAAW;QACX;AAER;IADI;;AAGJ;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;AACtC","sourcesContent":[".root {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n\n    @media (--large) {\n        display: grid;\n        grid-template-columns: 248px auto;\n        grid-gap: 20px;\n    }\n}\n\n.offerCard {\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 8px;\n\n    @media (--large) {\n        border: 1px solid var(--dark-tertiary-new-color);\n        padding: 24px;\n        border-radius: 6px;\n        flex-direction: column;\n        gap: 16px;\n        position: relative;\n    }\n}\n\n.cards {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n\n    @media (--large) {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        grid-gap: 16px;\n        border: 1px solid var(--premium-solid-color);\n        padding: 24px;\n        border-radius: 6px;\n    }\n}\n\n.transferIcon {\n    display: none;\n\n    @media (--large) {\n        display: flex;\n        border-radius: 6px;\n        border: 1px solid var(--premium-solid-color);\n        background-color: var(--darkest-color);\n        position: absolute;\n        padding: 7px;\n        top: 20px;\n        left: -28px;\n        z-index: 2;\n\n        > svg {\n            width: 40px;\n            height: 40px;\n        }\n    }\n}\n\n.card {\n    width: 100%;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n\n    @media (--mobile) {\n        padding-top: 8px;\n        width: 33vw;\n\n        &:nth-child(2) {\n            position: absolute;\n            left: 50%;\n            transform: translateX(-50%);\n            padding-top: 0;\n        }\n\n        &:last-child {\n            position: relative;\n            z-index: 2;\n        }\n    }\n}\n\n.cardName {\n    color: var(--tertiary-color);\n    text-transform: uppercase;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 2;\n    letter-spacing: 0.6px;\n    text-align: center;\n\n    @media (--large) {\n        padding: 12px 16px;\n    }\n}\n\n.cardImage {\n    width: 100%;\n    height: auto;\n    max-width: 180px;\n    margin: 0 auto;\n    aspect-ratio: 0.64;\n    min-width: 115px;\n    border-radius: 8px;\n    cursor: pointer;\n\n    @media (--tiny-only) {\n        max-width: 115px;\n    }\n\n    @media (--large) {\n        max-width: 246px;\n    }\n}\n\n.starBlock {\n    margin: 0 auto;\n    margin-bottom: 8px;\n    color: var(--main-color);\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n    display: flex;\n    justify-content: center;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:not(.active):hover {\n            .iconStarBg {\n                fill: #1E2028;\n            }\n        }\n    }\n\n    &.active {\n        fill: var(--main-color);\n\n        .iconStarBg {\n            fill: var(--main-color);\n        }\n\n        .iconStarMain {\n            fill: #090A0E;\n        }\n    }\n\n    @media (--large) {\n        margin-bottom: 16px;\n    }\n}\n\n.iconStar {\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n\n    @media (--large) {\n        width: 50px;\n        height: 50px;\n    }\n}\n\n.iconStarMain {\n    transition: fill 0.25s ease-in-out;\n}\n\n.iconStarBg {\n    fill: transparent;\n    transition: fill 0.25s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MarketplaceStage__root--DvSZT`,
	"offerCard": `MarketplaceStage__offerCard--pEtjo`,
	"cards": `MarketplaceStage__cards--Mxple`,
	"transferIcon": `MarketplaceStage__transferIcon--l5nXW`,
	"card": `MarketplaceStage__card--LF4IN`,
	"cardName": `MarketplaceStage__cardName--A0lrE`,
	"cardImage": `MarketplaceStage__cardImage--gqayM`,
	"starBlock": `MarketplaceStage__starBlock--H0sc2`,
	"active": `MarketplaceStage__active--R5rqO`,
	"iconStarBg": `MarketplaceStage__iconStarBg--voPe6`,
	"iconStarMain": `MarketplaceStage__iconStarMain--wErAt`,
	"iconStar": `MarketplaceStage__iconStar--KyObA`
};
export default ___CSS_LOADER_EXPORT___;
